module.exports = __webpack_public_path__ + "img/payment-with-card-dark.a098cfcc.svg";